import { Link } from "react-router-dom";

function ServicesSection() {
  return (
    <section className="bg-white py-6 md:py-8 lg:py-12 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-6 md:mb-8 lg:mb-12">
          <h2 className="font-bold text-black mb-2 md:mb-4 text-lg md:text-xl lg:text-2xl xl:text-3xl">Our Services</h2>
          <p className="text-gray-900 text-sm md:text-base lg:text-lg">Top-Rated Rides & Transfers</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {/* Card 1: City-to-city rides */}
          <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
              <img 
                src="blog12.png" 
                alt="City-to-city rides"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            <div className="p-3 md:p-4 lg:p-6">
              <h3 className="font-bold text-black mb-2 md:mb-3 lg:mb-4 text-sm md:text-base lg:text-lg"> Airport Limo Service in NYC </h3>
              <p className="text-gray-900 mb-3 md:mb-4 lg:mb-6 leading-relaxed text-xs md:text-sm lg:text-base">
                Skip the stress of changing a hack at the field. Our New York limo service provides timely 
transfers to and from JFK, LaGuardia, and Newark  airfields. Your motorist tracks your flight and 
delays for you at advents, ready to help with luggage and  insure a comfortable lift to your 
destination.
              </p>
              <Link 
                to="/airport-transfer-service"
                className="bg-black border-2 border-white text-white px-3 md:px-4 lg:px-5 py-2 md:py-2.5 lg:py-3 font-semibold hover:bg-gray-900 transition-colors text-xs md:text-sm lg:text-base inline-block"
              >
                READ MORE
              </Link>
            </div>
          </div>

          {/* Card 8: Group Transportation */}
          <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
              <img 
                src="con.webp" 
                alt="Group Transportation"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            <div className="p-3 md:p-4 lg:p-6">
              <h3 className="font-bold text-black mb-2 md:mb-3 lg:mb-4 text-sm md:text-base lg:text-lg">Event & Party Transportation</h3>
              <p className="text-gray-900 mb-3 md:mb-4 lg:mb-6 leading-relaxed text-xs md:text-sm lg:text-base">
                From  hops and bachelorette parties to musicales and red- carpet events, our limousine 
reimbursement in NYC adds glamour to any special occasion. Lift with musketeers, enjoy music, 
and make your night truly special.  
              </p>
              <Link 
                to="/concerts-events-limo-service"
                className="bg-black border-2 border-white text-white px-3 md:px-4 lg:px-5 py-2 md:py-2.5 lg:py-3 font-semibold hover:bg-gray-900 transition-colors text-xs md:text-sm lg:text-base inline-block"
              >
                READ MORE
              </Link>
            </div>
          </div>

          {/* Card 3: Airport transfers */}
          <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
              <img 
                src="wed1.webp" 
                alt="Airport transfers"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            <div className="p-3 md:p-4 lg:p-6">
              <h3 className="font-bold text-black mb-2 md:mb-3 lg:mb-4 text-sm md:text-base lg:text-lg"> Marriage Limo Service </h3>
              <p className="text-gray-900 mb-3 md:mb-4 lg:mb-6 leading-relaxed text-xs md:text-sm lg:text-base">
                Make your big day indelible with a luxurious New York limousine. Our elegant white stretch 
                limos and black  buses  are perfect for  marriages, anniversaries, and engagement events. 
                Arrive in complication and let our motorists handle every detail.  
              </p>
              <Link 
                to="/wedding-limousine-service"
                className="bg-black border-2 border-white text-white px-3 md:px-4 lg:px-5 py-2 md:py-2.5 lg:py-3 font-semibold hover:bg-gray-900 transition-colors text-xs md:text-sm lg:text-base inline-block"
              >
                READ MORE
              </Link>
            </div>
          </div>

          {/* Card 5: Corporate Limo Service */}
          <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
              <img 
                src="may1.webp" 
                alt="Corporate Limo Service"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            <div className="p-3 md:p-4 lg:p-6">
              <h3 className="font-bold text-black mb-2 md:mb-3 lg:mb-4 text-sm md:text-base lg:text-lg">Corporate Limo Service</h3>
              <p className="text-gray-900 mb-3 md:mb-4 lg:mb-6 leading-relaxed text-xs md:text-sm lg:text-base">
                Professional transportation for business executives. Reliable, punctual service for corporate events, meetings, and airport transfers.
              </p>
              <Link 
                to="/corporate-limo-service"
                className="bg-black border-2 border-white text-white px-3 md:px-4 lg:px-5 py-2 md:py-2.5 lg:py-3 font-semibold hover:bg-gray-900 transition-colors text-xs md:text-sm lg:text-base inline-block"
              >
                READ MORE
              </Link>
            </div>
          </div>

          {/* Card 7: Group Transportation */}
          <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
              <img 
                src="service7.jpeg" 
                alt="Group Transportation"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            <div className="p-3 md:p-4 lg:p-6">
              <h3 className="font-bold text-black mb-2 md:mb-3 lg:mb-4 text-sm md:text-base lg:text-lg">NYC City tenures  </h3>
              <p className="text-gray-900 mb-3 md:mb-4 lg:mb-6 leading-relaxed text-xs md:text-sm lg:text-base">
                Explore New York like nowhere ahead. Visit Times Square, Central Park, the Brooklyn Bridge, 
the Statue of Liberty, and more  each from the comfort of a luxury New York limo. Our motorists 
double as original attendants to make your trip memorable. 
              </p>
              <Link 
                to="/cruise-transfer-limo-service"
                className="bg-black border-2 border-white text-white px-3 md:px-4 lg:px-5 py-2 md:py-2.5 lg:py-3 font-semibold hover:bg-gray-900 transition-colors text-xs md:text-sm lg:text-base inline-block"
              >
                READ MORE
              </Link>
            </div>
          </div>
          
          {/* Card 2: Chauffeur hailing */}
          <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
              <img 
                src="vol1.webp" 
                alt="Chauffeur hailing"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            <div className="p-3 md:p-4 lg:p-6">
              <h3 className="font-bold text-black mb-2 md:mb-3 lg:mb-4 text-sm md:text-base lg:text-lg">Hourly Limo Settlements</h3>
              <p className="text-gray-900 mb-3 md:mb-4 lg:mb-6 leading-relaxed text-xs md:text-sm lg:text-base">
               Need inflexibility? Our hourly limo service in NYC gives you the freedom to hire an auto and 
motorist by the hour. Perfect for shopping days, business errands, or sightseeing around 
Manhattan.
              </p>
              <Link 
                to="/hourly-limo-service"
                className="bg-black border-2 border-white text-white px-3 md:px-4 lg:px-5 py-2 md:py-2.5 lg:py-3 font-semibold hover:bg-gray-900 transition-colors text-xs md:text-sm lg:text-base inline-block"
              >
                READ MORE
              </Link>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;









